export const BANNER_DESCRIPTION_WIDTH = {
  SIZE_10: '--banner-description-width-size-10', // Homepage
  SIZE_20: '--banner-description-width-size-20', // TV Series
  SIZE_30: '--banner-description-width-size-30', // Movies
  SIZE_40: '--banner-description-width-size-40', // TV Channels
  SIZE_50: '--banner-description-width-size-50', // Details pages
  SIZE_60: '--banner-description-width-size-60', // Player cover
} as const
export type BANNER_DESCRIPTION_WIDTH =
  (typeof BANNER_DESCRIPTION_WIDTH)[keyof typeof BANNER_DESCRIPTION_WIDTH]
